// src/App.js
// Composant racine Fynho - assemble tous les providers - NE PAS MODIFIER

import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import './i18n'; // Initialise i18next
import './styles/GlobalStyles.css';
import './styles/variables.css';

import { ThemeProvider } from './context/ThemeContext';
import { LanguageProvider } from './context/LanguageContext';
import { ListingsProvider } from './context/ListingsContext';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';

import AppRoutes from './routes/AppRoutes';

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider>
        <LanguageProvider>
          <AuthProvider>
            <ListingsProvider>
              <NotificationProvider>
                <AppRoutes />
              </NotificationProvider>
            </ListingsProvider>
          </AuthProvider>
        </LanguageProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;